import { ActionType } from "../types/store-types";
import { IError } from "../types/errors";
import { ValidationTypes } from "../fields/validationTypes";

/* - Data Types - */

export interface IValidationMessages {
    [ValidationTypes.URL]: string;
    [ValidationTypes.EMAIL]: string;
    [ValidationTypes.DOMAIN]: string;
    [ValidationTypes.DIGITS]: string;
    [ValidationTypes.LETTERS]: string;
    [ValidationTypes.REQUIRED]: string;
    [ValidationTypes.MIN_MAX_DATE]: string;
    [ValidationTypes.MIN_MAX_QUANTITY]: string;
    [ValidationTypes.MIN_MAX_SIZE]: string;
    [ValidationTypes.FILE_TYPE_FORMAT]: string;
    [ValidationTypes.MIN_MAX_STRING_LENGTH]: string;
    [ValidationTypes.MIN_MAX_OPTIONS]: string;
}

export interface IChangeValidationMessageRequest {
    [key: string]: string;
}

export interface IChangeValidationMessageSuccess {}
export interface IChangeValidationMessageFailure extends IError {
    prevState: IValidationMessages;
}

/* - Action Types - */

export enum ValidationMessagesTypes {
    INIT_VALIDATION_MESSAGES = "VALIDATIONS.INIT_MESSAGES",
    CHANGE_VALIDATION_MESSAGE_REQUEST = "VALIDATIONS.CHANGE_VALIDATION_MESSAGES_REQUEST",
    CHANGE_VALIDATION_MESSAGE_SUCCESS = "VALIDATIONS.CHANGE_VALIDATION_MESSAGES_SUCCESS",
    CHANGE_VALIDATION_MESSAGE_FAILURE = "VALIDATIONS.CHANGE_VALIDATION_MESSAGES_FAILURE",
}
/* - Action Interfaces  - */

export type InitValidationMessagesActionType = ActionType<
    ValidationMessagesTypes.INIT_VALIDATION_MESSAGES,
    IChangeValidationMessageSuccess
>;

export type ChangeValidationMessageRequestActionType = ActionType<
    ValidationMessagesTypes.CHANGE_VALIDATION_MESSAGE_REQUEST,
    IChangeValidationMessageRequest
>;

export type ChangeValidationMessageSuccessActionType = ActionType<
    ValidationMessagesTypes.CHANGE_VALIDATION_MESSAGE_SUCCESS,
    IChangeValidationMessageSuccess
>;
export type ChangeValidationMessageFailureActionType = ActionType<
    ValidationMessagesTypes.CHANGE_VALIDATION_MESSAGE_FAILURE,
    IChangeValidationMessageFailure
>;
